export const stringToColor = (string: string) => {
  let hash = 0
  let i

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash)
  }

  let color = "#"

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff
    color += `00${value.toString(16)}`.slice(-2)
  }

  return color
}

export const getInitials = (name: string) => {
  const parts = name.trim().split(/\s+/).filter(Boolean)

  const firstPart = parts[0]
  if (!firstPart) return "?"

  const secondPart = parts[1]
  if (!secondPart) return firstPart[0]?.toUpperCase() ?? "?"

  const first = firstPart[0] ?? ""
  const second = secondPart[0] ?? ""
  return `${first}${second}`.toUpperCase() || "?"
}

export const indexOfOccurrence = (haystack: string, needle: string, occurrence?: number) => {
  if (!occurrence) return -1

  let counter = 0
  let index = -1
  do {
    index = haystack.indexOf(needle, index + 1)
  } while (index !== -1 && ++counter < occurrence)

  return index
}

export const isNumericString = (value: unknown): value is string =>
  typeof value === "string" && value.trim() !== "" && isFinite(Number(value))
